import type { ComponentProps } from "react";
import { Link } from "react-router";
import { prefetchRetreatDetail } from "@/lib/retreats";

type LinkProps = ComponentProps<typeof Link>;

type RetreatLinkProps = Omit<LinkProps, "to"> & {
  slug: string;
  to?: LinkProps["to"];
};

export default function RetreatLink({
  slug,
  to,
  onFocus,
  onPointerEnter,
  onTouchStart,
  ...props
}: RetreatLinkProps) {
  const target = to ?? `/retreats/${slug}`;
  const prefetch = () => prefetchRetreatDetail(slug);

  return (
    <Link
      {...props}
      to={target}
      onFocus={(event) => {
        prefetch();
        onFocus?.(event);
      }}
      onPointerEnter={(event) => {
        prefetch();
        onPointerEnter?.(event);
      }}
      onTouchStart={(event) => {
        prefetch();
        onTouchStart?.(event);
      }}
    />
  );
}
